import { cardSvg } from '../cards';
import { coverBg, fade, mix, n, rng, shadowInk, star, tint, warm, type ArtPal } from './kit';

/**
 * Golden Flower (炸金花): a fan of three hearts Q-K-A (顺金, the second-best hand) over a card back, a soft gold glow
 * and a few sparkles. The cards are the game's own art (art/cards.ts), inlined with their own id prefixes.
 * No text, no glyphs, no chips or felt (docs/art-prompts.md).
 */
export function zhajinhuaCover(P: ArtPal, p: string): string {
  const cx = 452;
  const cy = 206;
  const top = P.dark ? mix(P.bg, P.red, 0.12) : tint(P.red, 0.9);
  const mid = P.dark ? mix(P.panel, P.gold, 0.06) : tint(P.gold, 0.88);
  const bg = coverBg(p, P, top, mid, P.bg, [cx, cy]);
  const theme = P.dark ? 'dark' : 'light';
  const inner = (card: number | 'back', id: string) => cardSvg(card, theme, `${p}${id}`).replace(/^<svg[^>]*>/, '').replace(/<\/svg>$/, '');
  // 100 × 140 card art scaled ×1.55, rotated around the bottom centre of the fan
  const place = (card: number | 'back', id: string, angle: number, dx: number) =>
    `<g transform="rotate(${angle} ${cx} ${cy + 150}) translate(${n(cx - 77 + dx)} ${cy - 112}) scale(1.55)">${inner(card, id)}</g>`;
  const r = rng(88);
  let sparks = '';
  for (let i = 0; i < 10; i++) {
    const a = r() * Math.PI * 2;
    const d = 150 + r() * 70;
    sparks += `<polygon points="${star(cx + Math.cos(a) * d, cy - 20 + Math.sin(a) * d * 0.6, 4 + r() * 5, 1.5 + r(), 4)}" fill="${i % 2 ? warm(P) : tint(warm(P), 0.4)}"/>`;
  }
  return (
    `<defs>${bg.defs}${fade(`${p}sh`, shadowInk(P), P.dark ? 0.5 : 0.16)}${fade(`${p}gw`, warm(P), P.dark ? 0.45 : 0.4)}</defs>` +
    bg.body +
    `<ellipse cx="${cx + 10}" cy="${cy + 128}" rx="150" ry="14" fill="url(#${p}sh)"/>` +
    `<ellipse cx="${cx}" cy="${cy - 10}" rx="190" ry="140" fill="url(#${p}gw)"/>` +
    sparks +
    place('back', 'b', -26, -18) +
    place(41, 'q', -13, -6) + // Q♥
    place(45, 'k', 0, 0) + // K♥
    place(49, 'a', 13, 6) // A♥
  );
}
